import { OnBoardingPage } from '@/graphql/generated/graphql';
import { getPage } from '@/services/on-boarding/onboarding.service';
import { useState, useEffect } from 'react';

export default function useOnBoardingPage() {
  const [page, setPage] = useState<OnBoardingPage | null>(null);

  useEffect(() => {
    (async () => {
      const page = await getPage();
      setPage(page?.page);
    })();
  }, []);

  return { page };
}
